import { render, staticRenderFns } from "./authorization-success.vue?vue&type=template&id=8a47b064&scoped=true"
import script from "./authorization-success.vue?vue&type=script&lang=ts"
export * from "./authorization-success.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a47b064",
  null
  
)

export default component.exports